import React from "react";
// replace with your actual image path

const ArchitecturalHardware = () => {
  return (
    <section className="tc-service-details py-5">
      <div className="container">
        <div className="row align-items-center">
          
          {/* IMAGE SIDE */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <img
              src="\home2\assets\img\services\geze.png"
              alt="Architectural Hardware"
              className="img-fluid rounded-3 shadow-sm"
            />
          </div>

          {/* CONTENT SIDE */}
          <div className="col-lg-6">
            <h2 className="sub-title mb-4">Architectural Hardware</h2>
            <p className="mt-4 mt-lg-0 color-666 fsz-18 lh-lg wow fadeInUp slow mb-4">
              At <strong>Artisan Guild Infra</strong>, we offer premium-grade 
              architectural hardware solutions that combine durability, 
              functionality, and style. Our selection of hardware enhances 
              architectural aesthetics while ensuring reliable performance 
              for modern buildings.
            </p>

            <div className="solution-item mb-80">
              <h4
                className="fsz-30 fw-600 mb-30 wow fadeInUp slow"
                data-wow-delay="0.2s"
              >
                1. Geze Hardware
              </h4>
              <ul
                className="dots-list fsz-18 color-666 wow fadeInUp slow"
                data-wow-delay="0.2s"
              >
                <li className="d-flex my-3">
                  <span className="icon me-3">•</span> Innovative and high-quality hardware for doors, windows, and automatic systems.
                </li>
                <li className="d-flex my-3">
                  <span className="icon me-3">•</span> Designed for long-lasting performance, safety, and aesthetic integration.
                </li>
                <li className="d-flex my-3">
                  <span className="icon me-3">•</span> Ideal for commercial and residential buildings with modern design requirements.
                </li>
              </ul>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ArchitecturalHardware;
